// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.isModalView ? `14px` : `10px`)};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    padding: 0 0 20px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-height: 76px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 10px;
`;

export const Title = styled.h1`
  font-size: 16px;
  width: 100%;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-weight: bold;
  text-transform: uppercase;
  padding: 0;
  border-bottom: 3px solid #000;
  margin: 0;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    font-size: 14px;
  }
`;
